import { ref } from "vue";
import { getParam } from "@utiles/index";
const LANG_MAP = [
  "zh-CN",
  "zh-TW",
  "en-US",
  "ar-SA",
  "de-DE",
  "es-ES",
  "fr-FR",
  "id-ID",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "pl-PL",
  "pt-PT",
  "ru-RU",
  "th-TH",
  "tr-TR",
  "vi-VN",
];

const checkLanguage = (lang) => {
  let res = "";
  let languageList = LANG_MAP;
  if (lang) {
    if (lang.indexOf("-") > -1) {
      for (let i = 0; i < languageList.length; i++) {
        if (languageList[i] === lang) {
          res = languageList[i];
        }
      }
    } else {
      const reg = new RegExp(lang, "g");
      for (let i = 0; i < languageList.length; i++) {
        if (reg.test(languageList[i].toLowerCase())) {
          res = languageList[i];
        }
      }
    }
  }
  return res || "en-US";
};
export const nowLang = ref("");
export const defaultLang = ref("");

export const language = {
  defaultLang: defaultLang.value || "",
  init() {
    const lang =
      this.getUrlLang() || this.getBrowserLang() || this.getDefaultLang();
    this.setLang(checkLanguage(lang));
  },
  setLang(lang: string) {
    document
      .getElementsByTagName("html")[0]
      .setAttribute("dir", lang == "ar-SA" ? "rtl" : "ltr");
    nowLang.value = lang;
  },
  getDefaultLang() {
    return this.defaultLang;
  },
  getUrlLang() {
    return getParam("appLanguage") || getParam("language");
  },
  getBrowserLang() {
    const lang = window.navigator.language;
    if (lang.includes("-")) {
      const langArr = lang.split("-");
      const realLang = `${langArr[0].toLowerCase()}-${langArr[1].toUpperCase()}`;
      return LANG_MAP.includes(realLang) ? realLang : false;
    } else {
      const realLang = lang.toLowerCase();
      let res = "";
      for (const key of LANG_MAP) {
        const langkey = key.split("-")[0];
        if (realLang === langkey) {
          res = key;
          break;
        }
      }
      return res;
    }
  },
  getLang() {
    return nowLang.value;
  },
};
language.init();
